document.addEventListener('DOMContentLoaded', function () {
    let topic = jQuery("body").hasClass("home") ? "home" : jQuery(".current-menu-item").closest("li.current-menu-parent").children("a").text().toLowerCase() + " || " + jQuery(".current-menu-item > a").text().toLowerCase();
    topic = topic === " || " ? jQuery("head > title").text().replace(" | Viseven", "") : topic;
    topic = topic.substring(0, 4) === " || " ? topic.replace(" || ", "") : topic;
    const initInterval = setInterval(() => { 
        if (typeof window.creatioFormsData !== 'undefined') {
            clearInterval(initInterval);
            window.creatioFormsData.forEach(data => {
                let form = document.getElementById(data.form7id);
                let config = {
                    fields: {
                        "PhoneNumber": data.phonenumber,
                        "Phone": data.phone,
                        "FullName": data.fullname, // Name of a contact
                        "Email": data.email, // Contact's email
                        "FirstName": data.firstname, // First name
                        "LastName": data.lastname, // Last name
                        "JobTitle": data.jobtitle, // Job title
                        "Account": data.account, // Company
                        "AccountIndustry": data.accountindustryhide,
                        "Notes": data.notes,
                        "UsrContactPartnership": data.usrcontactpartnershiphide,
                        "UsrContactInterest": data.usrcontactinteresthide,
                        "UsrTopicToDiscuss": data.usrtopictodiscuss,
                        "CountryStr": data.countryhide,
                        "CityStr": "#user-city-hide",
                        "Referrer": "#user-ref-hide",
                        "UsrXAamznMarketplaceToken": "#x-amzn-marketplace-token",
                        "UsrXAmznMarketplaceOfferType": "#x-amzn-marketplace-offer-type",
                        "UsrFreeTrial": "#free-trial",
                        "UsrScore": "#form-score",
                        "UsrRequiredProduct": data.usrrequiredproduct,
                        "UsrReasonOfInquiry": data.reasonofinquiryhide,
                        "UsrCXSummitUS": data.usrcxsummitus,
                        "Unsubscribe": data.unsubscribefromservices,
                        "UsrBlog": data.unsubscribeblog,
                        "UsrNewsletter": 'form#' + data.form7id + ' input[name="usrNewsletter"]',
                        "UsrSpecialPromotionsAndOffers": data.usrvisevenconsent,
                        "UsrEventsWebinarsInvitations": data.usreventswebinarsinvitations,
                        "UsrPrivacyNotice": 'form#' + data.form7id + ' input[name="usrPrivacyNotice"]',
                        "UsrPrivacyNoticeSpecialPromotions": 'form#' + data.form7id + ' input[name="usrPrivacyNoticeSpecialPromotions"]',
                        "Subscribe": data.subscribetoservices,
                        "UsrFormName": 'form#' + data.form7id + ' input[name="usrFormName"]',
                        "UsrFormUrl": 'form#' + data.form7id + ' input[name="usrFormUrl"]',
                        "Contact": data.contact,
                        "UsrHRCommunication": data.usrhrcommunication,
                        "UsrSurvey": 'form#' + data.form7id + ' input[name="usrSurvey"]'
                    },
                    contactFields: {
                        "PhoneNumber": data.phonenumber,
                        "Phone": data.phone,
                        "FullName": data.fullname, // Name of a contact
                        "Email": data.email, // Contact's email
                        "FirstName": data.firstname, // First name
                        "LastName": data.lastname, // Last name
                        "JobTitle": data.jobtitle, // Job title
                        "Account": data.account, // Company
                        "AccountIndustry": data.accountindustryhide,
                        "Notes": data.notes,
                        "UsrContactPartnership": data.usrcontactpartnershiphide,
                        "UsrContactInterest": data.usrcontactinteresthide,
                        "UsrTopicToDiscuss": data.usrtopictodiscuss,
                        "UsrHRCommunication": data.usrhrcommunication,
                        "CountryStr": data.countryhide,
                        "CityStr": "#user-city-hide",
                        "Referrer": "#user-ref-hide",
                        "Contact": data.contact
                    },
                    options: {
                        "disableRefererPolicy": true
                    },
                    customFields: { "WebFormId": data.creatioid },
                    landingId: data.creatioid,
                    serviceUrl: "https://viseven.creatio.com/0/ServiceModel/GeneratedObjectWebFormService.svc/SaveWebFormObjectData",
                    redirectUrl: ""
                }
                landing.initLanding(config);

                let usrsurvey = [];
                let data_servey = {};

                createAndHydrateInput(data.form7id, 'usrFormName', document.title);
                createAndHydrateInput(data.form7id, 'usrFormUrl', window.location.href);

                createAndHydrateInput(data.form7id, 'usrSurvey', '');
                let privacyCheckbox = form.querySelector('input[name="privacy"]');

                if (data.usrnewsletter === 'active') createAndHydrateInput(data.form7id, 'usrNewsletter', 'true');
                if (data.usrprivacynotice === 'active') createAndHydrateInput(data.form7id, 'usrPrivacyNotice', 'By submitting this form, I hereby consent to the given personal data being used by Viseven to send me information materials defined in the Privacy Policy, which I have read and agree. I understand that I can change my communication preferences anytime.');
                if (data.usrprivacynoticespecialpromotions === 'active') {
                    if (privacyCheckbox !== null) {
                        privacyCheckbox.addEventListener('change', (e) => {
                            if (e.target.checked) {
                                createAndHydrateInput(data.form7id, 'usrPrivacyNoticeSpecialPromotions', 'Yes, I would like to receive communications from Viseven with marketing materials, promotions and offers.');
                            } else {
                                createAndHydrateInput(data.form7id, 'usrPrivacyNoticeSpecialPromotions', '');
                            }
                        })
                    }
                }

                if (data.usrvisevenconsent !== 'css-selector') {
                    if (privacyCheckbox !== null) {
                        let userConsent = form.querySelector(data.usrvisevenconsent);
                        if (userConsent) {
                            userConsent.value = privacyCheckbox.checked ? 'true' : 'false';

                            privacyCheckbox.addEventListener('change', (e) => {
                                userConsent.value = privacyCheckbox.checked ? 'true' : 'false';
                            });
                        }
                    }
                }

                jQuery(data.usrvisevenconsent).click(function () {
                    if (jQuery(this).val() === "true") {
                        jQuery(this).val("false");
                    } else {
                        jQuery(this).val("true");
                    }
                });

                jQuery(data.usrvisevenconsent).on("change", function (e) {
                    jQuery(data.usrvisevenconsenthide).val(jQuery(data.usrvisevenconsent).val());
                });

                jQuery("body").on("DOMNodeInserted", function (event) {

                    jQuery('input[name="marketing_software"]').change(function () {
                        var inp_val = jQuery(this).val();
                        if (jQuery(this).val() === 'Other :') {
                            data_servey.marketing_software = inp_val;
                            jQuery('#marketing_software_other').change(function () {
                                if (jQuery(this).val().length > 0) {
                                    data_servey.marketing_software = inp_val + jQuery(this).val();
                                }
                            });
                        } else {
                            data_servey.marketing_software = jQuery(this).val();
                        }
                    });

                    jQuery('textarea[name="main_chalenges"]').change(function () {
                        data_servey.main_chalenges = jQuery(this).val();
                    });

                    jQuery(data.accountindustry).on("change", function (e) {
                        var fieldIdIndustry = jQuery(data.accountindustry + " option:selected").text();
                        if (jQuery("body").attr("data-lang") === "fr") {
                            switch (fieldIdIndustry) {
                                case "Construction":
                                    fieldIdIndustry = "Construction"
                                    break;
                                case "Services financiers":
                                    fieldIdIndustry = "Financial services"
                                    break;
                                case "Services aux entreprises/conseil":
                                    fieldIdIndustry = "Business services/consulting"
                                    break;
                                case "Assurances":
                                    fieldIdIndustry = "Insurance"
                                    break;
                                case "Publicité":
                                    fieldIdIndustry = "Advertising"
                                    break;
                                case "Technologies et services de l'information":
                                    fieldIdIndustry = "Information technology and services"
                                    break;
                                case "Santé":
                                    fieldIdIndustry = "Healthcare"
                                    break;
                                case "Relations publiques et communication":
                                    fieldIdIndustry = "Public relations and communications"
                                    break;
                                case "Communications":
                                    fieldIdIndustry = "Communications"
                                    break;
                                case "Médias":
                                    fieldIdIndustry = "Media"
                                    break;
                                case "Biotechnologie":
                                    fieldIdIndustry = "Biotechnology"
                                    break;
                                case "Dispositifs médicaux ":
                                    fieldIdIndustry = "Medical devices"
                                    break;
                                case "Santé animale":
                                    fieldIdIndustry = "Animal Health"
                                    break;
                                case "Revendeur":
                                    fieldIdIndustry = "Resseller"
                                    break;
                                case "Services événementiels":
                                    fieldIdIndustry = "Events services"
                                    break;
                                case "Marketing et publicité":
                                    fieldIdIndustry = "Marketing and advertising"
                                    break;
                                case "Autre":
                                    fieldIdIndustry = "Other"
                                    break;
                                case "Pharmacie":
                                    fieldIdIndustry = "Pharmaceuticals"
                                    break;
                                case "Éducation":
                                    fieldIdIndustry = "Education"
                                    break;
                            }
                        }
                        if (jQuery("body").attr("data-lang") === "es") {
                            switch (fieldIdIndustry) {
                                case "Construcción":
                                    fieldIdIndustry = "Construction"
                                    break;
                                case "Servicios financieros":
                                    fieldIdIndustry = "Financial services"
                                    break;
                                case "Servicios empresariales/consultoría":
                                    fieldIdIndustry = "Business services/consulting"
                                    break;
                                case "Seguros":
                                    fieldIdIndustry = "Insurance"
                                    break;
                                case "Publicidad":
                                    fieldIdIndustry = "Advertising"
                                    break;
                                case "Servicios y tecnologías de la información":
                                    fieldIdIndustry = "Information technology and services"
                                    break;
                                case "Cuidado de la salud":
                                    fieldIdIndustry = "Healthcare"
                                    break;
                                case "Relaciones públicas y comunicaciones":
                                    fieldIdIndustry = "Public relations and communications"
                                    break;
                                case "Comunicaciones":
                                    fieldIdIndustry = "Communications"
                                    break;
                                case "Medios de comunicación":
                                    fieldIdIndustry = "Media"
                                    break;
                                case "Biotecnología":
                                    fieldIdIndustry = "Biotechnology"
                                    break;
                                case "Dispositivos médicos ":
                                    fieldIdIndustry = "Medical devices"
                                    break;
                                case "Salud animal":
                                    fieldIdIndustry = "Animal Health"
                                    break;
                                case "Revendedor":
                                    fieldIdIndustry = "Resseller"
                                    break;
                                case "Servicios de eventos":
                                    fieldIdIndustry = "Events services"
                                    break;
                                case "Marketing y publicidad":
                                    fieldIdIndustry = "Marketing and advertising"
                                    break;
                                case "Otros":
                                    fieldIdIndustry = "Other"
                                    break;
                                case "Farmacéuticos":
                                    fieldIdIndustry = "Pharmaceuticals"
                                    break;
                                case "Educación":
                                    fieldIdIndustry = "Education"
                                    break;
                            }
                        }
                        jQuery(data.accountindustryhide).val(fieldIdIndustry);
                    });

                    jQuery(data.country).on("change", function (e) {

                        var fieldIdCountry = jQuery(data.country + " option:selected").text();
                        if (jQuery("body").attr("data-lang") === "fr") {
                            switch (fieldIdCountry) {
                                case "Albanie":
                                    fieldIdCountry = "Albania"
                                    break;
                                case "Algérie":
                                    fieldIdCountry = "Algeria"
                                    break;
                                case "Samoa américaines":
                                    fieldIdCountry = "American Samoa"
                                    break;
                                case "Andorre":
                                    fieldIdCountry = "Andorra"
                                    break;
                                case "Antarctique":
                                    fieldIdCountry = "Antarctica"
                                    break;
                                case "Antigua-et-Barbuda":
                                    fieldIdCountry = "Antigua and Barbuda"
                                    break;
                                case "Argentine":
                                    fieldIdCountry = "Argentina"
                                    break;
                                case "Arménie":
                                    fieldIdCountry = "Armenia"
                                    break;
                                case "Australie":
                                    fieldIdCountry = "Australia"
                                    break;
                                case "Autriche":
                                    fieldIdCountry = "Austria"
                                    break;
                                case "Azerbaïdjan":
                                    fieldIdCountry = "Azerbaijan"
                                    break;
                                case "Bahreïn":
                                    fieldIdCountry = "Bahrain"
                                    break;
                                case "Barbade":
                                    fieldIdCountry = "Barbados"
                                    break;
                                case "Bélarus":
                                    fieldIdCountry = "Belarus"
                                    break;
                                case "Belgique":
                                    fieldIdCountry = "Belgium"
                                    break;
                                case "Bénin":
                                    fieldIdCountry = "Benin"
                                    break;
                                case "Bermudes":
                                    fieldIdCountry = "Bermuda"
                                    break;
                                case "Bhoutan":
                                    fieldIdCountry = "Bhutan"
                                    break;
                                case "Bolivie":
                                    fieldIdCountry = "Bolivia"
                                    break;
                                case "Bosnie-Herzégovine":
                                    fieldIdCountry = "Bosnia and Herzegovina"
                                    break;
                                case "Brésil":
                                    fieldIdCountry = "Brazil"
                                    break;
                                case "Océan Indien britannique Territoire":
                                    fieldIdCountry = "British Indian Ocean Territory"
                                    break;
                                case "Îles Vierges britanniques":
                                    fieldIdCountry = "British Virgin Islands"
                                    break;
                                case "Bulgarie":
                                    fieldIdCountry = "Bulgaria"
                                    break;
                                case "Cambodge":
                                    fieldIdCountry = "Cambodia"
                                    break;
                                case "Cameroun":
                                    fieldIdCountry = "Cameroon"
                                    break;
                                case "Cap-Vert":
                                    fieldIdCountry = "Cape Verde"
                                    break;
                                case "Îles Caïmans":
                                    fieldIdCountry = "Cayman Islands"
                                    break;
                                case "République centrafricaine":
                                    fieldIdCountry = "Central African Republic"
                                    break;
                                case "Tchad":
                                    fieldIdCountry = "Chad"
                                    break;
                                case "Chili":
                                    fieldIdCountry = "Chile"
                                    break;
                                case "Chine":
                                    fieldIdCountry = "China"
                                    break;
                                case "Colombie":
                                    fieldIdCountry = "Colombia"
                                    break;
                                case "Comores":
                                    fieldIdCountry = "Comoros"
                                    break;
                                case "Croatie":
                                    fieldIdCountry = "Croatia"
                                    break;
                                case "Chypre":
                                    fieldIdCountry = "Cyprus"
                                    break;
                                case "République tchèque":
                                    fieldIdCountry = "Czech Republic"
                                    break;
                                case "République démocratique du Congo":
                                    fieldIdCountry = "Democratic Republic of the Congo"
                                    break;
                                case "Danemark":
                                    fieldIdCountry = "Denmark"
                                    break;
                                case "Dominique":
                                    fieldIdCountry = "Dominica"
                                    break;
                                case "République dominicaine":
                                    fieldIdCountry = "Dominican Republic"
                                    break;
                                case "Timor oriental":
                                    fieldIdCountry = "East Timor"
                                    break;
                                case "Équateur":
                                    fieldIdCountry = "Ecuador"
                                    break;
                                case "Égypte":
                                    fieldIdCountry = "Egypt"
                                    break;
                                case "Guinée équatoriale":
                                    fieldIdCountry = "Equatorial Guinea"
                                    break;
                                case "Érythrée":
                                    fieldIdCountry = "Eritrea"
                                    break;
                                case "Estonie":
                                    fieldIdCountry = "Estonia"
                                    break;
                                case "Éthiopie":
                                    fieldIdCountry = "Ethiopia"
                                    break;
                                case "Îles Falkland":
                                    fieldIdCountry = "Falkland Islands"
                                    break;
                                case "Îles Féroé":
                                    fieldIdCountry = "Faroe Islands"
                                    break;
                                case "Fidji":
                                    fieldIdCountry = "Fiji"
                                    break;
                                case "Finlande":
                                    fieldIdCountry = "Finland"
                                    break;
                                case "Polynésie française":
                                    fieldIdCountry = "French Polynesia"
                                    break;
                                case "Gambie":
                                    fieldIdCountry = "Gabon"
                                    break;
                                case "Géorgie":
                                    fieldIdCountry = "Georgia"
                                    break;
                                case "Allemagne":
                                    fieldIdCountry = "Germany"
                                    break;
                                case "Grèce":
                                    fieldIdCountry = "Greece"
                                    break;
                                case "Groenland":
                                    fieldIdCountry = "Greenland"
                                    break;
                                case "Grenade":
                                    fieldIdCountry = "Grenada"
                                    break;
                                case "Guernesey":
                                    fieldIdCountry = "Guernsey"
                                    break;
                                case "Guinée":
                                    fieldIdCountry = "Guinea"
                                    break;
                                case "Guinée-Bissau":
                                    fieldIdCountry = "Guinea-Bissau"
                                    break;
                                case "Haïti":
                                    fieldIdCountry = "Haiti"
                                    break;
                                case "Hongrie":
                                    fieldIdCountry = "Hungary"
                                    break;
                                case "Islande":
                                    fieldIdCountry = "Iceland"
                                    break;
                                case "Inde":
                                    fieldIdCountry = "India"
                                    break;
                                case "Indonésie":
                                    fieldIdCountry = "Indonesia"
                                    break;
                                case "Irak":
                                    fieldIdCountry = "Iraq"
                                    break;
                                case "Irlande":
                                    fieldIdCountry = "Ireland"
                                    break;
                                case "Israël":
                                    fieldIdCountry = "Israel"
                                    break;
                                case "Italie":
                                    fieldIdCountry = "Italy"
                                    break;
                                case "Côte d'Ivoire":
                                    fieldIdCountry = "Ivory Coast"
                                    break;
                                case "Jamaïque":
                                    fieldIdCountry = "Jamaica"
                                    break;
                                case "Japon":
                                    fieldIdCountry = "Japan"
                                    break;
                                case "Jordanie":
                                    fieldIdCountry = "Jordan"
                                    break;
                                case "Kazakhstan":
                                    fieldIdCountry = "Kazakhstan"
                                    break;
                                case "Royaume du Swaziland":
                                    fieldIdCountry = "Kingdom of Swaziland"
                                    break;
                                case "Corée":
                                    fieldIdCountry = "Korea"
                                    break;
                                case "Koweït":
                                    fieldIdCountry = "Kuwait"
                                    break;
                                case "Kirghizistan":
                                    fieldIdCountry = "Kyrgyzstan"
                                    break;
                                case "Lettonie":
                                    fieldIdCountry = "Latvia"
                                    break;
                                case "Liban":
                                    fieldIdCountry = "Lebanon"
                                    break;
                                case "Libéria":
                                    fieldIdCountry = "Liberia"
                                    break;
                                case "Libye":
                                    fieldIdCountry = "Libya"
                                    break;
                                case "Lituanie":
                                    fieldIdCountry = "Lithuania"
                                    break;
                                case "Macao":
                                    fieldIdCountry = "Macau"
                                    break;
                                case "Macédoine":
                                    fieldIdCountry = "Macedonia"
                                    break;
                                case "Malaisie":
                                    fieldIdCountry = "Malaysia"
                                    break;
                                case "Malte":
                                    fieldIdCountry = "Malta"
                                    break;
                                case "Îles Marshall":
                                    fieldIdCountry = "Marshall Islands"
                                    break;
                                case "Mauritanie":
                                    fieldIdCountry = "Mauritania"
                                    break;
                                case "Maurice":
                                    fieldIdCountry = "Mauritius"
                                    break;
                                case "Mexique":
                                    fieldIdCountry = "Mexico"
                                    break;
                                case "Micronésie":
                                    fieldIdCountry = "Micronesia"
                                    break;
                                case "Afrique centrale":
                                    fieldIdCountry = "Middle Africa"
                                    break;
                                case "Moldavie":
                                    fieldIdCountry = "Moldova"
                                    break;
                                case "Mongolie":
                                    fieldIdCountry = "Mongolia"
                                    break;
                                case "Monténégro":
                                    fieldIdCountry = "Montenegro"
                                    break;
                                case "Maroc":
                                    fieldIdCountry = "Morocco"
                                    break;
                                case "Namibie":
                                    fieldIdCountry = "Namibia"
                                    break;
                                case "Népal":
                                    fieldIdCountry = "Nepal"
                                    break;
                                case "Pays-Bas":
                                    fieldIdCountry = "Netherlands"
                                    break;
                                case "Antilles néerlandaises":
                                    fieldIdCountry = "Netherlands Antilles"
                                    break;
                                case "Nouvelle-Calédonie":
                                    fieldIdCountry = "New Caledonia"
                                    break;
                                case "Nouvelle-Zélande":
                                    fieldIdCountry = "New Zealand"
                                    break;
                                case "Norvège":
                                    fieldIdCountry = "Norway"
                                    break;
                                case "Papouasie-Nouvelle-Guinée":
                                    fieldIdCountry = "Papua New Guinea"
                                    break;
                                case "Pérou":
                                    fieldIdCountry = "Peru"
                                    break;
                                case "Pologne":
                                    fieldIdCountry = "Poland"
                                    break;
                                case "Porto Rico":
                                    fieldIdCountry = "Puerto Rico"
                                    break;
                                case "République du Kosovo":
                                    fieldIdCountry = "Republic of Kosovo"
                                    break;
                                case "Roumanie":
                                    fieldIdCountry = "Romania"
                                    break;
                                case "Russie":
                                    fieldIdCountry = "Russia"
                                    break;
                                case "Saint Barthélemy":
                                    fieldIdCountry = "Saint Barthelemy"
                                    break;
                                case "Saint He lena":
                                    fieldIdCountry = "Saint Helena"
                                    break;
                                case "Saint-Kitts-et-Nevis":
                                    fieldIdCountry = "Saint Kitts and Nevis"
                                    break;
                                case "Saint-Marin":
                                    fieldIdCountry = "San Marino"
                                    break;
                                case "Arabie saoudite":
                                    fieldIdCountry = "Saudi Arabia"
                                    break;
                                case "Sénégal":
                                    fieldIdCountry = "Senegal"
                                    break;
                                case "Serbie":
                                    fieldIdCountry = "Serbia"
                                    break;
                                case "Singapour":
                                    fieldIdCountry = "Singapore"
                                    break;
                                case "Slovaquie":
                                    fieldIdCountry = "Slovakia"
                                    break;
                                case "Slovénie":
                                    fieldIdCountry = "Slovenia"
                                    break;
                                case "Îles Salomon":
                                    fieldIdCountry = "Solomon Islands"
                                    break;
                                case "Somalie":
                                    fieldIdCountry = "Somalia"
                                    break;
                                case "Sud Afrique":
                                    fieldIdCountry = "South Africa"
                                    break;
                                case "Soudan du Sud":
                                    fieldIdCountry = "South Sudan"
                                    break;
                                case "Espagne":
                                    fieldIdCountry = "Spain"
                                    break;
                                case "Soudan":
                                    fieldIdCountry = "Sudan"
                                    break;
                                case "Suède":
                                    fieldIdCountry = "Sweden"
                                    break;
                                case "Suisse":
                                    fieldIdCountry = "Switzerland"
                                    break;
                                case "Syrie":
                                    fieldIdCountry = "Syria"
                                    break;
                                case "Taïwan":
                                    fieldIdCountry = "Taiwan"
                                    break;
                                case "Tadjikistan":
                                    fieldIdCountry = "Tajikistan"
                                    break;
                                case "Tanzanie":
                                    fieldIdCountry = "Tanzania"
                                    break;
                                case "Thaïlande":
                                    fieldIdCountry = "Thailand"
                                    break;
                                case "Gambie":
                                    fieldIdCountry = "The Gambia"
                                    break;
                                case "Trinité-et-Tobago":
                                    fieldIdCountry = "Trinidad and Tobago"
                                    break;
                                case "Tunisie":
                                    fieldIdCountry = "Tunisia"
                                    break;
                                case "Turquie":
                                    fieldIdCountry = "Turkey"
                                    break;
                                case "Turkménistan":
                                    fieldIdCountry = "Turkmenistan"
                                    break;
                                case "États-Unis":
                                    fieldIdCountry = "USA"
                                    break;
                                case "Ouganda":
                                    fieldIdCountry = "Uganda"
                                    break;
                                case "Émirats arabes unis":
                                    fieldIdCountry = "United Arab Emirates"
                                    break;
                                case "Royaume-Uni":
                                    fieldIdCountry = "United Kingdom"
                                    break;
                                case "Ouzbékistan":
                                    fieldIdCountry = "Uzbekistan"
                                    break;
                                case "Yémen":
                                    fieldIdCountry = "Yemen"
                                    break;
                                case "Zambie":
                                    fieldIdCountry = "Zambia"
                                    break;
                            }
                        }
                        if (jQuery("body").attr("data-lang") === "es") {
                            switch (fieldIdCountry) {
                                case "Afganistán":
                                    fieldIdCountry = "Afghanistan"
                                    break;
                                case "Argelia":
                                    fieldIdCountry = "Algeria"
                                    break;
                                case "Samoa Americana":
                                    fieldIdCountry = "American Samoa"
                                    break;
                                case "Antártico":
                                    fieldIdCountry = "Antarctica"
                                    break;
                                case "Antigua y Barbuda":
                                    fieldIdCountry = "Antigua and Barbuda"
                                    break;
                                case "Azerbaiyán":
                                    fieldIdCountry = "Azerbaijan"
                                    break;
                                case "Bahrein":
                                    fieldIdCountry = "Bahrain"
                                    break;
                                case "Bielorrusia":
                                    fieldIdCountry = "Belarus"
                                    break;
                                case "Bélgica":
                                    fieldIdCountry = "Belgium"
                                    break;
                                case "Belice":
                                    fieldIdCountry = "Belize"
                                    break;
                                case "Bermudas":
                                    fieldIdCountry = "Bermuda"
                                    break;
                                case "Bután":
                                    fieldIdCountry = "Bhutan"
                                    break;
                                case "Bosnia y Herzegovina":
                                    fieldIdCountry = "Bosnia and Herzegovina"
                                    break;
                                case "Brasil":
                                    fieldIdCountry = "Brazil"
                                    break;
                                case "Océano Índico Territorio Británico":
                                    fieldIdCountry = "British Indian Ocean Territory"
                                    break;
                                case "Islas Vírgenes Británicas":
                                    fieldIdCountry = "British Virgin Islands"
                                    break;
                                case "Camboya":
                                    fieldIdCountry = "Cambodia"
                                    break;
                                case "Camerún":
                                    fieldIdCountry = "Cameroon"
                                    break;
                                case "Canadá":
                                    fieldIdCountry = "Canada"
                                    break;
                                case "Cabo Verde":
                                    fieldIdCountry = "Cape Verde"
                                    break;
                                case "Islas Caimán":
                                    fieldIdCountry = "Cayman Islands"
                                    break;
                                case "República Centroafricana":
                                    fieldIdCountry = "Central African Republic"
                                    break;
                                case "Comoras":
                                    fieldIdCountry = "Comoros"
                                    break;
                                case "Croacia":
                                    fieldIdCountry = "Croatia"
                                    break; Curazao
                                case "Curazao":
                                    fieldIdCountry = "Curacao"
                                    break;
                                case "Chipre":
                                    fieldIdCountry = "Cyprus"
                                    break;
                                case "República Checa":
                                    fieldIdCountry = "Czech Republic"
                                    break;
                                case "República Democrática del Congo":
                                    fieldIdCountry = "Democratic Republic of the Congo"
                                    break;
                                case "Dinamarca":
                                    fieldIdCountry = "Denmark"
                                    break;
                                case "Yibuti":
                                    fieldIdCountry = "Djibouti"
                                    break;
                                case "República Dominicana":
                                    fieldIdCountry = "Dominican Republic"
                                    break;
                                case "Este Timor":
                                    fieldIdCountry = "East Timor"
                                    break;
                                case "Egipto":
                                    fieldIdCountry = "Egypt"
                                    break;
                                case "Guinea Ecuatorial":
                                    fieldIdCountry = "Equatorial Guinea"
                                    break;
                                case "Etiopía":
                                    fieldIdCountry = "Ethiopia"
                                    break;
                                case "Islas Malvinas":
                                    fieldIdCountry = "Falkland Islands"
                                    break;
                                case "Islas Feroe":
                                    fieldIdCountry = "Faroe Islands"
                                    break;
                                case "Finlandia":
                                    fieldIdCountry = "Finland"
                                    break;
                                case "Francia":
                                    fieldIdCountry = "France"
                                    break;
                                case "Polinesia Francesa":
                                    fieldIdCountry = "French Polynesia"
                                    break;
                                case "Gabón":
                                    fieldIdCountry = "Gabon"
                                    break;
                                case "Géorgie":
                                    fieldIdCountry = "Georgia"
                                    break;
                                case "Alemania":
                                    fieldIdCountry = "Germany"
                                    break;
                                case "Grecia":
                                    fieldIdCountry = "Greece"
                                    break;
                                case "Groenlandia":
                                    fieldIdCountry = "Greenland"
                                    break;
                                case "Granada":
                                    fieldIdCountry = "Grenada"
                                    break;
                                case "Haití":
                                    fieldIdCountry = "Haiti"
                                    break;
                                case "Hungría":
                                    fieldIdCountry = "Hungary"
                                    break;
                                case "Islandia":
                                    fieldIdCountry = "Iceland"
                                    break;
                                case "Irán":
                                    fieldIdCountry = "Iran"
                                    break;
                                case "Irlanda":
                                    fieldIdCountry = "Ireland"
                                    break;
                                case "Italia":
                                    fieldIdCountry = "Italy"
                                    break;
                                case "Costa de Marfil":
                                    fieldIdCountry = "Ivory Coast"
                                    break;
                                case "Japón":
                                    fieldIdCountry = "Japan"
                                    break;
                                case "Jordania":
                                    fieldIdCountry = "Jordan"
                                    break;
                                case "Kazajstán":
                                    fieldIdCountry = "Kazakhstan"
                                    break;
                                case "Kenia":
                                    fieldIdCountry = "Kenya"
                                    break;
                                case "Reino de Suazilandia":
                                    fieldIdCountry = "Kingdom of Swaziland"
                                    break;
                                case "Corea":
                                    fieldIdCountry = "Korea"
                                    break;
                                case "Kirguistán":
                                    fieldIdCountry = "Kyrgyzstan"
                                    break;
                                case "Letonia":
                                    fieldIdCountry = "Latvia"
                                    break;
                                case "Líbano":
                                    fieldIdCountry = "Lebanon"
                                    break;
                                case "Lesoto":
                                    fieldIdCountry = "Lesotho"
                                    break;
                                case "Libia":
                                    fieldIdCountry = "Libya"
                                    break;
                                case "Lituanie":
                                    fieldIdCountry = "Lithuania"
                                    break; Luxemburgo
                                case "Luxemburgo":
                                    fieldIdCountry = "Luxembourg"
                                    break;
                                case "Macao":
                                    fieldIdCountry = "Macau"
                                    break;
                                case "Malasia":
                                    fieldIdCountry = "Malaysia"
                                    break;
                                case "Malte":
                                    fieldIdCountry = "Malta"
                                    break;
                                case "Maldivas":
                                    fieldIdCountry = "Maldives"
                                    break;
                                case "Malí":
                                    fieldIdCountry = "Mali"
                                    break;
                                case "Islas Marshall":
                                    fieldIdCountry = "Marshall Islands"
                                    break;
                                case "Mauricio":
                                    fieldIdCountry = "Mauritius"
                                    break;
                                case "México":
                                    fieldIdCountry = "Mexico"
                                    break;
                                case "África Central":
                                    fieldIdCountry = "Middle Africa"
                                    break;
                                case "Moldavia":
                                    fieldIdCountry = "Moldova"
                                    break;
                                case "Mónaco":
                                    fieldIdCountry = "Monaco"
                                    break;
                                case "Marruecos":
                                    fieldIdCountry = "Morocco"
                                    break;
                                case "Países Bajos":
                                    fieldIdCountry = "Netherlands"
                                    break;
                                case "Antillas Holandesas":
                                    fieldIdCountry = "Netherlands Antilles"
                                    break;
                                case "Nueva Caledonia":
                                    fieldIdCountry = "New Caledonia"
                                    break;
                                case "Nueva Zelanda":
                                    fieldIdCountry = "New Zealand"
                                    break;
                                case "Níger":
                                    fieldIdCountry = "Niger"
                                    break;
                                case "Noruega":
                                    fieldIdCountry = "Norway"
                                    break;
                                case "Omán":
                                    fieldIdCountry = "Oman"
                                    break;
                                case "Pakistán":
                                    fieldIdCountry = "Pakistan"
                                    break;
                                case "Palestina":
                                    fieldIdCountry = "Palestine"
                                    break;
                                case "Panamá":
                                    fieldIdCountry = "Panama"
                                    break;
                                case "Papúa Nueva Guinea":
                                    fieldIdCountry = "Papua New Guinea"
                                    break;
                                case "Perú":
                                    fieldIdCountry = "Peru"
                                    break;
                                case "Filipinas":
                                    fieldIdCountry = "Philippines"
                                    break;
                                case "Polonia":
                                    fieldIdCountry = "Poland"
                                    break;
                                case "República de Kosovo":
                                    fieldIdCountry = "Republic of Kosovo"
                                    break;
                                case "Rumania":
                                    fieldIdCountry = "Romania"
                                    break;
                                case "Rusia":
                                    fieldIdCountry = "Russia"
                                    break;
                                case "Ruanda":
                                    fieldIdCountry = "Rwanda"
                                    break;
                                case "San Bartolomé":
                                    fieldIdCountry = "Saint Barthelemy"
                                    break;
                                case "Santa Elena":
                                    fieldIdCountry = "Saint Helena"
                                    break;
                                case "San Cristóbal y Nieves":
                                    fieldIdCountry = "Saint Kitts and Nevis"
                                    break;
                                case "Arabia Saudita":
                                    fieldIdCountry = "Saudi Arabia"
                                    break;
                                case "Sierra Leona":
                                    fieldIdCountry = "Sierra Leone"
                                    break;
                                case "Singapur":
                                    fieldIdCountry = "Singapore"
                                    break;
                                case "Eslovaquia":
                                    fieldIdCountry = "Slovakia"
                                    break;
                                case "Eslovenia":
                                    fieldIdCountry = "Slovenia"
                                    break;
                                case "Islas Salomón":
                                    fieldIdCountry = "Solomon Islands"
                                    break;
                                case "Sudáfrica":
                                    fieldIdCountry = "South Africa"
                                    break;
                                case "Sudán del Sur":
                                    fieldIdCountry = "South Sudan"
                                    break;
                                case "España":
                                    fieldIdCountry = "Spain"
                                    break;
                                case "Sudán ":
                                    fieldIdCountry = "Sudan"
                                    break;
                                case "Sudán":
                                    fieldIdCountry = "Sudan"
                                    break;
                                case "Surinam":
                                    fieldIdCountry = "Suriname"
                                    break;
                                case "Suecia":
                                    fieldIdCountry = "Sweden"
                                    break;
                                case "Suiza":
                                    fieldIdCountry = "Switzerland"
                                    break;
                                case "Siria":
                                    fieldIdCountry = "Syria"
                                    break;
                                case "Taiwán":
                                    fieldIdCountry = "Taiwan"
                                    break;
                                case "Tayikistán":
                                    fieldIdCountry = "Tajikistan"
                                    break;
                                case "Tailandia":
                                    fieldIdCountry = "Thailand"
                                    break;
                                case "Gambia":
                                    fieldIdCountry = "The Gambia"
                                    break;
                                case "Trinidad y Tobago":
                                    fieldIdCountry = "Trinidad and Tobago"
                                    break;
                                case "Túnez":
                                    fieldIdCountry = "Tunisia"
                                    break;
                                case "Turquía":
                                    fieldIdCountry = "Turkey"
                                    break;
                                case "Turkmenistán":
                                    fieldIdCountry = "Turkmenistan"
                                    break;
                                case "Turkmenistán ":
                                    fieldIdCountry = "Turkmenistan"
                                    break;
                                case "Estados Unidos":
                                    fieldIdCountry = "USA"
                                    break; Ucrania
                                case "Ucrania":
                                    fieldIdCountry = "Ukraine"
                                    break;
                                case "Emiratos Árabes Unidos":
                                    fieldIdCountry = "United Arab Emirates"
                                    break;
                                case "Reino Unido":
                                    fieldIdCountry = "United Kingdom"
                                    break;
                                case "Uzbekistán":
                                    fieldIdCountry = "Uzbekistan"
                                    break;
                            }
                        }
                        jQuery(data.countryhide).val(fieldIdCountry);
                    });

                    jQuery(data.usrcontactpartnership).on("change", function (e) {
                        var fieldIdContactPartnership = jQuery(data.usrcontactpartnership + " option:selected").text();
                        if (jQuery("body").attr("data-lang") === "fr") {
                            switch (fieldIdContactPartnership) {
                                case "Partenaire de contenu":
                                    fieldIdContactPartnership = "Content Partner"
                                    break;
                                case "Partenaire technologique":
                                    fieldIdContactPartnership = "Technology Partner"
                                    break;
                                case "Partenaire Revendeur":
                                    fieldIdContactPartnership = "Reselling Partner"
                                    break;
                                case "Partenaire expert":
                                    fieldIdContactPartnership = "Expert Partner"
                                    break;
                            }
                        }
                        if (jQuery("body").attr("data-lang") === "es") {
                            switch (fieldIdContactPartnership) {
                                case "Socio de contenido":
                                    fieldIdContactPartnership = "Content Partner"
                                    break;
                                case "Socio tecnológico":
                                    fieldIdContactPartnership = "Technology Partner"
                                    break;
                                case "Socio distribuidor":
                                    fieldIdContactPartnership = "Reselling Partner"
                                    break;
                                case "Socio experto":
                                    fieldIdContactPartnership = "Expert Partner"
                                    break;
                            }
                        }
                        jQuery(data.usrcontactpartnershiphide).val(fieldIdContactPartnership);
                    });

                    jQuery(data.usrcontactinterest).on("change", function (e) {
                        var fieldIdContactInterest = jQuery(data.usrcontactinterest + " option:selected").text();
                        if (jQuery("body").attr("data-lang") === "fr") {
                            switch (fieldIdContactInterest) {
                                case "Usine de contenu numérique":
                                    fieldIdContactInterest = "Digital Content Factory"
                                    break;
                                case "Plateforme d'expérience de contenu eWizard":
                                    fieldIdContactInterest = "eWizard Content Experience Platform"
                                    break;
                                case "Contenu modulaire":
                                    fieldIdContactInterest = "Modular Content"
                                    break;
                                case "Omnicanal":
                                    fieldIdContactInterest = "Omnichannel"
                                    break;
                                case "Production de contenu":
                                    fieldIdContactInterest = "Content Production"
                                    break;
                                case "Application mobile":
                                    fieldIdContactInterest = "Mobile Apps"
                                    break;
                                case "Transformation numérique":
                                    fieldIdContactInterest = "Digital Transformation"
                                    break;
                                case "Autre":
                                    fieldIdContactInterest = "Other"
                                    break;
                            }
                        }
                        if (jQuery("body").attr("data-lang") === "es") {
                            switch (fieldIdContactInterest) {
                                case "Fábrica de contenido digital":
                                    fieldIdContactInterest = "Digital Content Factory"
                                    break;
                                case "Plataforma de experiencia de contenido eWizard":
                                    fieldIdContactInterest = "eWizard Content Experience Platform"
                                    break;
                                case "Contenido modular":
                                    fieldIdContactInterest = "Modular Content"
                                    break;
                                case "Omnicanal":
                                    fieldIdContactInterest = "Omnichannel"
                                    break;
                                case "Producción de contenido":
                                    fieldIdContactInterest = "Content Production"
                                    break;
                                case "Aplicaciones móviles":
                                    fieldIdContactInterest = "Mobile Apps"
                                    break;
                                case "Transformación digital":
                                    fieldIdContactInterest = "Digital Transformation"
                                    break;
                                case "Otro":
                                    fieldIdContactInterest = "Other"
                                    break;
                            }
                        }
                        jQuery(data.usrcontactinteresthide).val(fieldIdContactInterest);
                    });

                    jQuery(data.usrtopictodiscuss).on("change", function (e) {
                        var fieldIdContactTopic = jQuery(data.usrtopictodiscuss + " option:selected").text();
                        jQuery(data.usrtopictodiscusshide).val(fieldIdContactTopic);
                    });

                    jQuery(data.usrrequiredproduct).on("change", function (e) {
                        var fieldIdRequiredProduct = jQuery(data.usrrequiredproduct + " option:selected").text();
                        jQuery(data.usrrequiredproducthide).val(fieldIdRequiredProduct);
                    });

                    jQuery(data.reasonofinquiry).on("change", function (e) {
                        var fieldIdReasonOfInquiry = jQuery(data.reasonofinquiry + " option:selected").text();
                        if (jQuery("body").attr("data-lang") === "fr") {
                            switch (fieldIdReasonOfInquiry) {
                                case "Produits et services":
                                    fieldIdReasonOfInquiry = "Product and Services"
                                    break;
                                case "Conseil gratuit":
                                    fieldIdReasonOfInquiry = "Free consultancy"
                                    break;
                                case "Partenariats":
                                    fieldIdReasonOfInquiry = "Partnerships"
                                    break;
                                case "Carrières":
                                    fieldIdReasonOfInquiry = "Careers"
                                    break;
                                case "Autre":
                                    fieldIdReasonOfInquiry = "Other"
                                    break;
                            }
                        }
                        if (jQuery("body").attr("data-lang") === "es") {
                            switch (fieldIdReasonOfInquiry) {
                                case "Productos y servicios":
                                    fieldIdReasonOfInquiry = "Product and Services"
                                    break;
                                case "Consultoría gratuita":
                                    fieldIdReasonOfInquiry = "Free consultancy"
                                    break;
                                case "Asociaciones":
                                    fieldIdReasonOfInquiry = "Partnerships"
                                    break;
                                case "Carreras":
                                    fieldIdReasonOfInquiry = "Careers"
                                    break;
                                case "Otros":
                                    fieldIdReasonOfInquiry = "Other"
                                    break;
                            }
                        }
                        jQuery(data.reasonofinquiryhide).val(fieldIdReasonOfInquiry);
                    });

                    jQuery(data.usrcxsummitus).on("change", function (e) {
                        var fieldIdContactPartnership = jQuery(data.usrcxsummitus + " option:selected").text();
                        jQuery(data.usrcxsummitushide).val(fieldIdContactPartnership);
                    });
                });

                document.addEventListener("wpcf7submit", function (event) {
                    var status = event.detail.status;
                    var tag_form = "#" + event.detail.unitTag + " " + ".wpcf7-submit";

                    jQuery(tag_form).prop("disabled", true); // disable button after clicking on button

                    setTimeout(function () {
                        jQuery(tag_form).prop("disabled", false);
                    }, 2000);

                    if (status === "mail_sent") {
                        if (data_servey.toString().length > 0) {
                            if (data_servey.digital_marketing === undefined) {
                                var dm_val = [];
                                jQuery('input[name="digital_marketing[]"]:checked').each(function () {
                                    var inp_val = jQuery(this).val();
                                    if (jQuery(this).val() === 'Other :') {
                                        dm_val.push(inp_val + jQuery('#digital_marketing_other').val());
                                    } else {
                                        dm_val.push(jQuery(this).val());
                                    }
                                });
                                data_servey.digital_marketing = dm_val;
                            }
                            if (data_servey.essential_elements === undefined) {
                                var ee_val = [];
                                jQuery('input[name="essential_elements[]"]:checked').each(function () {
                                    var inp_val = jQuery(this).val();
                                    if (jQuery(this).val() === 'Other resources or strategies :') {
                                        ee_val.push(inp_val + jQuery('#essential_elements_other').val());
                                    } else {
                                        ee_val.push(jQuery(this).val());
                                    }
                                });
                                data_servey.essential_elements = ee_val;
                            }
                            if (data_servey.specific_skills === undefined) {
                                var ss_val = [];
                                jQuery('input[name="specific_skills[]"]:checked').each(function () {
                                    var inp_val = jQuery(this).val();
                                    if (jQuery(this).val() === 'Other resources or strategies :') {
                                        ss_val.push(inp_val + jQuery('#specific_skills_other').val());
                                    } else {
                                        ss_val.push(jQuery(this).val());
                                    }
                                });
                                data_servey.specific_skills = ss_val;
                            }
                            if (data_servey.marketing_software === undefined) {
                                data_servey.marketing_software = jQuery('input[name="marketing_software"]').val();
                            }
                            usrsurvey.push(data_servey);
                            servey_str = JSON.stringify(usrsurvey);
                            jQuery('form#' + data.form7id + ' input[name="usrSurvey"]').val(servey_str);
                        }


                        if (event.detail.contactFormId == data.form7id) {
                            let countryField = form.querySelector(data.countryhide);
                            if (countryField) {
                                let selectedCountry = form.querySelector('.select2-selection--single .select2-selection__rendered').innerHTML;
                                countryField.setAttribute('value', selectedCountry);
                            }

                            // popup form
                            let i = setInterval(function () {
                                if (jQuery.trim(jQuery("#wpcf7-f" + data.form7id + "-o1 .wpcf7-response-output").html()) !== "") {

                                    clearInterval(i);

                                    var successfully_message = jQuery("#wpcf7-f" + data.form7id + "-o1 .wpcf7-response-output").text();
                                    jQuery("#wpcf7-f" + data.form7id + "-o1 form").append("<div class='successfully-msg'>" + successfully_message + "</div>");
                                    jQuery("#wpcf7-f" + data.form7id + "-o1 form").after(jQuery(".successfully-msg"));
                                    jQuery("#wpcf7-f" + data.form7id + "-o1 form").remove();

                                }
                            }, 100);

                            // classic form 
                            if (data.form7id !== 63569 && data.form7id !== 63458 && data.form7id !== 63982) {
                                let y = setInterval(function () {
                                    if (jQuery.trim(jQuery("form#" + data.form7id + " .wpcf7-response-output").html()) !== "") {
                                        // if found, stop the timer and call..
                                        clearInterval(y);

                                        var successfully_message_classic_form = jQuery("form#" + data.form7id + " .wpcf7-response-output").text();

                                        jQuery("form#" + data.form7id).append("<div id='successfully-msg-classic' class='successfully-msg'>" + successfully_message_classic_form + "</div>");
                                        jQuery("form#" + data.form7id).after(jQuery(".successfully-msg"));
                                        jQuery("form#" + data.form7id).remove();
                                    }
                                    var height_win = jQuery(window).height();
                                    if (jQuery.trim(jQuery("#successfully-msg-classic").html()) !== "") {
                                        jQuery("html, body").animate({
                                            scrollTop: jQuery("#successfully-msg-classic").offset().top - height_win / 2,
                                        }, 1000);
                                    }
                                }, 100);
                            }

                            landing.createObjectFromLanding(config);

                            /*----- Extend with GOOGLE ANALYTICS -----*/
                            // Save form send event into dataLayer
                            let gaEvent = jQuery(".swal2-container").hasClass("swal2-shown") ? data.usrformname + " form submit" : "";

                            if (gaEvent.length == "0" && jQuery(".vacancy_status").length > 0) {
                                gaEvent = capitalizeFirstLetter(jQuery(".vacancy_status").text().toLowerCase()) + " request";
                            } else if (gaEvent.length == "0") {
                                gaEvent = data.usrformname + " form submit";
                            }

                            if (dataLayer.length > 0) {
                                dataLayer.push({
                                    "event": gaEvent,
                                    "Data Layer - Event": gaEvent,
                                    "topic": topic
                                });
                            }

                            return false;
                        }
                    }
                });
            });
        }
    }, 1000);

    // TODO: refactor this some body
    jQuery('.search-results .search-element input, .search-no-results .search-element input').val('');

    jQuery(document).on('click', '.wpcf7-submit', function () {
        var form = jQuery(this).closest('form');
        jQuery('#popup-consent').val('true');

        if (['63071', '63120', '63132'].includes(form.attr('id'))) {
            var fName = form.find('#user_first_name').val();
            var lName = form.find('#user_last_name').val();

            if (fName && lName && form.find('#viseven-full-name').length) {
                form.find('#viseven-full-name').val(fName + ' ' + lName);
            } else if (!fName || !lName) {
                console.log('Error: First Name or Last Name is empty.');
            }
        }

    });

    setTimeout(function () {
        var titleValue = jQuery('title').text();
        jQuery('#viseven-form-name, #popup-viseven-form-name').val(titleValue);
        jQuery('#viseven-hr-communication').val('true');
    }, 5500);

    jQuery(".country-field").select2();
});

// Helper function
function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}

function createAndHydrateInput(formId, inputName, value) {
    let form = document.getElementById(formId);
    let input = form.querySelector('input[name="' + inputName + '"]');
    if (input == null) {
        input = document.createElement('input');
        input.type = 'hidden';
        input.setAttribute('name', inputName);
        form.appendChild(input);
    }
    input.setAttribute('value', value);
}
